if (!customElements.get('ingredients-dropdown')) {
  class IngredientsDropdown extends HTMLElement {
    constructor() {
      super();
      this.isOpenState = false;

      this.dropdown = this.querySelector('.js-product-ingredients-dropdown');
      this.dropdownItems = this.dropdown.querySelectorAll('.js-product-ingredients-dropdown__item');
      this.list = this.dropdown.querySelector('.js-product-ingredients-dropdown__list');
      this.elementHolder = this.querySelector('.js-product-ingredients-dropdown__element-holder');
      this.mediaHolder = this.querySelector('.js-product-ingredients__media-holder');

      this.classNames = {
        dropdownOpen: 'is-open',
        listVisible: 'is-visible',
        itemActive: 'is-active',
      };
    }

    connectedCallback() {
      if (!this.dropdown || this.dropdownItems.length === 0) return;

      // Set first item active
      this.dropdownItems[0].classList.add(this.classNames.itemActive);

      this.bindEvents();
    }

    bindEvents() {
      if (this.elementHolder) {
        this.elementHolder.addEventListener('click', this.toggleDropdown.bind(this));
      }

      this.dropdownItems.forEach((item) => {
        item.addEventListener('click', () => {
          this.selectItem(item);
        });
      });

      this.outsideClickHandler = (e) => {
        if (!this.contains(e.target) && this.isOpenState) {
          this.closeDropdown();
        }
      };

      document.addEventListener('click', this.outsideClickHandler);
    }

    toggleDropdown() {
      this.isOpenState ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      const { dropdownOpen, listVisible } = this.classNames;

      this.isOpenState = true;
      this.dropdown.classList.add(dropdownOpen);
      this.list?.classList.add(listVisible);
    }

    closeDropdown() {
      const { dropdownOpen, listVisible } = this.classNames;

      this.isOpenState = false;
      this.dropdown.classList.remove(dropdownOpen);
      this.list?.classList.remove(listVisible);
    }

    selectItem(item) {
      const { itemActive } = this.classNames;

      // Active state
      this.dropdownItems.forEach((el) => el.classList.remove(itemActive));
      item.classList.add(itemActive);

      const variantTitle = item.dataset.variantTitle;
      const variantImage = item.dataset.variantImage;
      const ingredientsImage = item.dataset.ingredientsImage;
      const ingredientsText = item.dataset.ingredientsText;

      // Update dropdown header
      this.updateElementHolder(variantTitle, variantImage);

      // Update ingredients content
      if (this.mediaHolder) {
        if (ingredientsImage) {
          this.updateImage(ingredientsImage, variantTitle);
        }

        if (ingredientsText) {
          this.updateText(ingredientsText);
        }
      }

      this.closeDropdown();
    }

    updateElementHolder(title, image) {
      const img = this.elementHolder.querySelector('img');
      const heading = this.elementHolder.querySelector('h3');

      if (img && image) img.src = image;
      if (heading && title) heading.textContent = title;
    }

    updateImage(imageUrl, altText = '') {
      const img = this.mediaHolder.querySelector('.js-product-ingredients-image img');
      if (!img) return;

      img.src = imageUrl;
      img.srcset = imageUrl;
      img.alt = altText;
    }

    updateText(text) {
      const textHolder = this.mediaHolder.querySelector('.js-product-ingredients-text');
      if (textHolder) {
        textHolder.innerHTML = text;
      }
    }
  }

  customElements.define('ingredients-dropdown', IngredientsDropdown);
}
